import { Component } from '@angular/core';
import { fade } from '@core/animations/animations';
import { Matter } from '@models/matter';
import { PropertyUsage } from '@models/title-insurance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { combineLatest, Observable } from 'rxjs';
import { TestHooks } from './fct.hooks';

@UntilDestroy()
@Component({
	selector: 'app-fct',
	templateUrl: './fct.component.html',
	styleUrls: ['./fct.component.scss'],
	animations: [fade()],
	standalone: false,
})
export class FctTitleInsuranceComponent {
	testHooks = TestHooks;
	public propertyUsage: PropertyUsage;
	public usageType = PropertyUsage;

	@Select(SelectedMatter.getSelected) matter$: Observable<Matter>;

	constructor() {
		combineLatest([this.matter$])
			.pipe(untilDestroyed(this))
			.subscribe(([_matter]) => {
				if (!_matter) {
					return;
				}

				const propertyUsage = _matter.propertyDetails?.propertyType?.usage;
				this.propertyUsage = propertyUsage;
			});
	}
}
